import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NecAccessToken } from './access-token';
import { NecErrorCollectService } from './../error-collect/error-collect.service';
import { NecLocalStorageService } from '../localStorage/local-storage.service';
import { NecUrl } from '../../model/url/url';
import { Observable } from 'rxjs';
import { UserService } from './../user/user.service';


/**
 * AccessTokenç¸å³æå¡ï¼åæ¬è®¾ç½®ãæ¥è¯¢ãå é¤ç­æ¥å£
 */
@Injectable()
export class NecAuthService {
  constructor(private http: HttpClient,
    private ls: NecLocalStorageService,
    private userService: UserService,
    private errorCollectService: NecErrorCollectService) {
  }

  /**
   * å¦æä¼ å, åä¸ºsetæ¹æ³; æ²¡æåæ°, åä¸ºgetæ¹æ³
   */
  authenticate(token?: NecAccessToken): boolean {
    if (token) {
      this.setToken(token);
      return true;
    }
    else {
      if (!this.ls.get('token')) {
        return false;
      }

      if (new Date().getTime() > this.ls.get('token').expire_time) {
        return false;
      }

      this.errorCollectService.init(this.userService.getUserInfo());
      return true;
    }
  }

  /**
   * è·åå­å¨çtokenä¿¡æ¯
   */
  getToken(): NecAccessToken {
    return this.ls.get('token');
  }

  /**
   * è®¾ç½®tokenä¿¡æ¯
   */
  setToken(token: NecAccessToken): void {
    token.expire_time = new Date().getTime() + token.expires_in * 1000;
    this.ls.set('token', token);
  }

  /**
   * æ¸é¤tokenä¿¡æ¯
   */
  clearToken(): void {
    this.ls.del('token');
  }

  /**
   * ç¨æ·ç»å½, è¯·æ±token
   */
  login(username: string, password: string, url = `${NecUrl.SERVER_URL}/auth/oauth/token`): Observable<NecAccessToken> {
    let postBody = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(btoa(password))}&grant_type=password&isBase64Password=true`;
    return this.http.post<NecAccessToken>(url, postBody, {
      headers: new HttpHeaders({
        'Authorization': 'Basic ' + btoa('web:'),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      })
    });
  }

  /**
   * ç¨æ·ç»åº, æ¸ç©ºtokenä¿¡æ¯
   */
  logout(): void {
    this.clearToken();
    this.errorCollectService.clear();
    this.ls.del('kyHCloudLoginParam');
  }
}
